<template>
  <ion-content class="ion-padding">
    <div class="ollaa-brand">
      <img :src="ollaaLogo" alt="Ollaa" class="ollaa-logo" />
      <p class="ollaa-subtitle">[Olá!] Admin</p>
    </div>
    <form @submit.prevent="handleLogin">
      <ion-list>
        <ion-item>
          <ion-input
            v-model="email"
            type="email"
            label="E-Mail"
            label-placement="stacked"
            autocomplete="email"
            required
          />
        </ion-item>
        <ion-item>
          <ion-input
            v-model="password"
            type="password"
            label="Passwort"
            label-placement="stacked"
            autocomplete="current-password"
            required
          />
        </ion-item>
      </ion-list>
      <ion-button
        type="submit"
        expand="block"
        :disabled="loading"
      >
        <ion-spinner v-if="loading" name="crescent" />
        <span v-else>Anmelden</span>
      </ion-button>
    </form>
  </ion-content>
</template>

<script>
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { presentError } from '@/util/alert';
import ollaaLogo from '@/assets/logo_ollaa.svg';

const firebaseErrorMessages = {
  'auth/wrong-password': 'Falsches Passwort.',
  'auth/user-not-found': 'Kein Konto mit dieser E-Mail gefunden.',
  'auth/invalid-credential': 'E-Mail oder Passwort ist falsch.',
  'auth/invalid-email': 'Ungültige E-Mail-Adresse.',
  'auth/too-many-requests': 'Zu viele Versuche. Bitte später erneut versuchen.',
  'auth/user-disabled': 'Dieses Konto wurde deaktiviert.',
};

export default {
  name: 'FirebaseLogin',
  data() {
    return {
      ollaaLogo,
      email: '',
      password: '',
      loading: false,
    };
  },
  methods: {
    async handleLogin() {
      this.loading = true;

      try {
        await firebase.auth().signInWithEmailAndPassword(this.email, this.password);
      } catch (error) {
        const message = firebaseErrorMessages[error.code]
          || error.message
          || 'Anmeldung fehlgeschlagen.';
        await presentError(this, message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ollaa-brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 32px;
}

.ollaa-logo {
  width: 80px;
  height: auto;
  display: block;
}

.ollaa-subtitle {
  margin: 12px 0 0;
  font-size: 1rem;
  color: #737373;
}
</style>
